import { apiInstance } from "shared/api";
import { GetRequestsParams, ApiRequestsResponse, RequestData } from "./types";

export const getRequests = (
  params?: GetRequestsParams,
): Promise<ApiRequestsResponse> =>
  apiInstance.get("/v1/requests", { params }).then((response) => response.data);

export const getRequestById = (id: string): Promise<RequestData> =>
  apiInstance.get(`/v1/requests/${id}`).then((response) => response.data);

export const acceptRequestByNumber = (number: string): Promise<RequestData> =>
  apiInstance
    .patch(`/v1/requests/${number}/accept`)
    .then((response) => response.data);

export const cancelRequestByNumber = (number: string): Promise<RequestData> =>
  apiInstance
    .delete(`/v1/requests/${number}`)
    .then((response) => response.data);

export const approveRequestByNumber = (number: string): Promise<RequestData> =>
  apiInstance
    .patch(`/v1/requests/${number}/approve`)
    .then((response) => response.data);
